import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Messages from 'pages/messages';
import AddMessage from 'pages/messages/add';
import Programs from 'pages/programs';
import AddProgram from 'pages/programs/add';
import {
  HOME,
  MESSAGES,
  PROGRAMS,
  ADD_MESSAGE,
  EDIT_MESSAGE,
  EDIT_PROGRAM,
  ADD_PROGRAM,
} from 'constants/routes';

const RoutesSwitch: React.FC<{}> = () => {
  return (
    <Switch>
      <Route path={HOME} component={Messages} exact />
      <Route path={ADD_MESSAGE} component={AddMessage} />
      <Route path={EDIT_MESSAGE} component={AddMessage} />
      <Route path={MESSAGES} component={Messages} />
      <Route path={ADD_PROGRAM} component={AddProgram} />
      <Route path={EDIT_PROGRAM} component={AddProgram} />
      <Route path={PROGRAMS} component={Programs} />
    </Switch>
  );
};

export default RoutesSwitch;
